import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BackBtnIcon, LogoutIcon } from "../icons";
import { ProfileImage } from "../images";
import { useDispatch, useSelector } from "react-redux";
import { nameFormatting, notify } from "../helpers/commonFunction";
import { Dropdown } from "react-bootstrap";
import { CustomImageCard, Loader } from "../components";
import { reqToForceUserLogout } from "../store/slice/userSlice";
import { commonMessage } from "../helpers/messages";
import { routes } from "../helpers/constants";
const MemoizedImageCard = React.memo(CustomImageCard);

const Header = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { user, loader } = useSelector((state) => state.userReducer);
  const [isOpen, setIsOpen] = useState(false);

  const handleUserLogout = () => {
    dispatch(reqToForceUserLogout({}));
    notify(commonMessage.logout, "success");
  };

  const backButtonPages = [routes.courseModule, routes.moduleViewing];

  return (
    <>
      {loader && <Loader />}
      <div className="lms-navbar">
        {backButtonPages.includes(location.pathname) ? (
          <div className="lms-navbar-content">
            <div className="lms-navbar-content-left has-back-button d-flex">
              <button
                type="button"
                className="back-arrow"
                onClick={() => navigate(-1)}
              >
                {BackBtnIcon}
              </button>
              <p className="lms-navbar-title text-uppercase">
                {location?.state?.title}
              </p>
            </div>
          </div>
        ) : (
          <div className="lms-navbar-content">
            <div className="lms-navbar-content-left">
              <p className="lms-navbar-title">RX LMS</p>
            </div>
            <Dropdown
              show={isOpen}
              onToggle={() => setIsOpen(!isOpen)}
              className="lms-navbar-profile-dropdown ms-auto"
            >
              <Dropdown.Toggle className="lms-navbar-user-profile">
                <span className="lms-profile-notification-count">
                  {user && nameFormatting(user)}
                </span>
                <MemoizedImageCard
                  src={user && user?.profile ? user?.profile : ProfileImage}
                  alt="Profile"
                  height={35}
                  imagePreview={false}
                />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <button
                  type="button"
                  className="lms-navbar-profile-logout-item dropdown-item logout-btn"
                  onClick={() => handleUserLogout("")}
                >
                  <span className="d-flex align-items-center">
                    <span className="me-2">{LogoutIcon}</span>
                    Logout
                  </span>
                </button>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
